/**
 * スムーススクロール
 */
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

/** ========================
 * 特定のターゲットをスムーススクロール
 * @param {HTMLElement} target - スクロールしたいHTML要素
 * @param {number} [offset=0] - スクロール位置のオフセット
 * ========================== */
function _smoothScroll(target, offset = 0) {
  if (!target) return;

  setTimeout(() => {
    let targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    let finalPosition = targetPosition - offset;

    gsap.to(window, {
      duration: 1,
      scrollTo: finalPosition,
      ease: 'power2.inOut'
    });
  }, 0);  // bodyScrollFixedの影響で位置がずれるのを防ぐため遅延させる
}

/** ========================
 * アンカーリンクがクリックされた際のスムーススクロールのイベントを初期化
 * @param {number} [offset=0] - スクロール位置のオフセット
 * ========================== */
function fnc_initAnchorScroll(offset = 0) {
  const anchors = document.querySelectorAll('a[href^="#"]:not([href^="#modal-"]):not([href^="#tab-"])');

  anchors.forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const href = this.getAttribute('href');

      // hrefが#pagetopの場合、ページのトップにスムーススクロール
      if (href === '#pagetop') {
        _smoothScroll(document.body, offset); // document.bodyをターゲットとしてページのトップにスクロール
      } else {
        let target = document.querySelector(href);
        if (target) {
          _smoothScroll(target, offset);
        }
      }
    });
  });
}

/** ========================
 * ページの読み込み時にURLのハッシュを確認し、
 * 対応するアンカー位置へスムーススクロールする
 * @param {number} [offset=0] - スクロール位置のオフセット
 * ========================== */
export function fnc_scrollToHashOnLoad(offset = 0) {
  let hash = window.location.hash;
  if (hash) {
    let target = document.querySelector(hash);
    if (target) {
      _smoothScroll(target, offset);
    }
  }
}

/** ========================
 * 実行
 * ========================== */
window.addEventListener('load', () => {
  fnc_initAnchorScroll(80);
  fnc_scrollToHashOnLoad(80);
}, false)
